


















import { Vue, Prop, Component, Watch } from 'vue-property-decorator'
import { env } from '@ivy/fts/envInfo/envInfo'
import * as utils from '@ivy/fts/utils'

@Component({
  name: 'DiscountSale',
  filters: {
    filterInt: function(price = '') {
      return price.toString().split('.')[0]
    },
    filterFloat: function(price = '') {
      return price.toString().split('.')[1] !== '00'
        ? parseFloat(price)
            .toString()
            .split('.')[1]
        : '00'
    },
    filterVipprice: function(price = '') {
      return parseFloat(price)
    },
  },
})
export default class DiscountSale extends Vue {
  @Prop() skuActivity: any[]
  @Prop() spu: any
  @Prop() skus: any[]
  @Prop() curLevel: any
  @Prop({ default: {} }) discountData: any
  @Prop() isApp: boolean
  @Prop() isVip: boolean
  timer: any = null
  canShow: boolean = false
  // discountData: any = {}
  limitTime = []
  limitTimeStr: string = ''
  get isDistribution() {
    return true
  }

  @Watch('curLevel.id')
  curLevelChanged(val, oldVal) {
    if (val) {
      this.countdown()
    }
  }

  @Watch('discountData.activity_type')
  discountlChanged(val, oldVal) {
    if (val) {
      this.countdown()
    }
  }

  get priceObj() {
    let price = {
      discountPrice: this.curLevel.salePrice,
      basePrice: this.curLevel.originSalePrice || this.curLevel.originPrice,
    }
    return price
  }
  get showOriginSalePrice() {
    if (
      this.curLevel.activities &&
      this.curLevel.activities.gift &&
      Object.keys(this.curLevel.activities.gift).length !== 0
    ) {
      return true
    } else {
      return false
    }
  }

  async mounted() {
    this.countdown()
  }

  async countdown() {
    let type = this.discountData.activity_type
    let end = this.discountData.end_time || ''
    const self = this
    // 结束时间小于当前时间
    if (
      !end ||
      (end && new Date(end.replace(/-/g, '/')).getTime() < Date.now())
    ) {
      this.limitTimeStr = '活动已结束'
      return
    }
    async function clock(end) {
      let msec =
        new Date(end.replace(/-/g, '/')).getTime() - new Date().getTime()
      // 倒计时没有了，刷新页面
      if (msec < 0) {
        if (self.timer) {
          clearInterval(self.timer)
        }
        await utils.sleep(200)
        return self.$emit('update-page')
      } else {
        let remainTime = Date.formatMs(msec, 'DD hh mm ss')
        let _remainTime = remainTime.split(' ')
        let _time = _remainTime.splice(-3).join(':')
        let day = _remainTime[0]
        let _day
        if (day === '00' || !day) {
          _day = ''
        } else {
          _day = Number(day) + '天'
        }

        self.limitTimeStr = `距结束 ${_day} ${_time}`
      }
    }
    if (this.timer) {
      clearInterval(this.timer)
    }
    clock(end)
    this.timer = setInterval(() => {
      clock(end)
    }, 1000)
  }
}
